import { Controller } from "@hotwired/stimulus"

// Handles opening and closing the sidebar menu on small screens
export default class extends Controller {
  toggle() {
    this.element.classList.toggle("sidebar-open")
  }

  close(event) {
    if (event?.target.closest("[data-menu-prevent-close]")) {
      return
    }

    this.element.classList.remove("sidebar-open")
  }
}
